export default (datetimeString: string): string => {
  const datetime = new Date(datetimeString);
  const now = new Date();
  const diffMs = now.getTime() - datetime.getTime();

  const suffix = "ago";

  const diffSeconds = Math.floor(diffMs / 1000);
  if (diffSeconds < 0) {
    return `2 seconds ${suffix}`;
  }
  if (diffSeconds < 60) {
    return `${diffSeconds} seconds ${suffix}`;
  }

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) {
    if (diffMinutes === 1) return `${diffMinutes} minute ${suffix}`;
    return `${diffMinutes} minutes ${suffix}`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    if (diffHours === 1) return `${diffHours} hour ${suffix}`;
    return `${diffHours} hours ${suffix}`;
  }

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 30) {
    if (diffDays === 1) return `${diffDays} day ${suffix}`;
    return `${diffDays} days ${suffix}`;
  }

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) {
    if (diffMonths === 1) return `${diffMonths} month ${suffix}`;
    return `${diffMonths} months ${suffix}`;
  }

  const diffYears = Math.floor(diffMonths / 12);
  if (diffYears === 1) return `${diffYears} year ${suffix}`;
  return `${diffYears} years ${suffix}`;
};
